<template>
    <b-form-group
        :label="
            $t('group_pair.personal_courses_for_student', {
                asterisk: groupIn.group_pair_options.course_student_link === 1 ? '*' : '',
                studentName: studentName,
            })
        ">
        <div v-if="course_personal_error">
            <b-alert
                show
                variant="danger">
                {{ course_error_text }}
            </b-alert>
        </div>

        <design-2021-apprentice-multiselect-component
            id="group-pair-courses-create"
            v-model="selectedCourses"
            :placeholder="$t('group_pair.select_courses')"
            label="name"
            :multiple-select="true"
            :options="coursesIn"
            :show-labels="false"
            :allow-empty="true"
            @input="emit()">
        </design-2021-apprentice-multiselect-component>
    </b-form-group>
</template>

<script>
export default {
    name: 'design-2021-group-pair-create-form-select-courses-student-component',
    props: ['groupIn', 'coursesIn', 'studentIn'],
    data() {
        return {
            studentId: this.studentIn.id,
            studentName: this.studentIn.name,
            selectedCourses: this.studentIn.selectedCourses,
            course_total_error: false,
            course_personal_error: false,
        };
    },

    methods: {
        emit() {
            this.$emit('log', { studentId: this.studentId, selectedCourses: this.selectedCourses });
        },
    },

    computed: {
        course_error_text() {
            const min = this.groupIn.group_pair_options.course_min;
            const max = this.groupIn.group_pair_options.course_max;

            if (min !== null && max === null) {
                return this.$t('group_pair.courses_must_be_at_least', { amount: min });
            }

            if (min === null && max !== null) {
                return this.$t('group_pair.courses_must_be_maximum', { amount: max });
            }

            return this.$t('group_pair.amount_of_courses_must_be_between', { min: min, max: max });
        },
    },
    watch: {
        selectedCourses: function (value) {
            const min = this.groupIn.group_pair_options.course_min;
            const max = this.groupIn.group_pair_options.course_max;

            if (min !== null && max === null) {
                this.course_personal_error = value.length < min;
            } else if (min === null && max !== null) {
                this.course_personal_error = value.length > max;
            } else if (min === null && max === null) {
                this.course_personal_error = false;
            } else if (min === max && value.length !== min) {
                this.course_personal_error = true;
            } else this.course_personal_error = !(value.length >= min && value.length <= max);
        },
    },
};
</script>

<style scoped></style>
